import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Header extends PureComponent {
    render() {
        return (
            <div className={styles.phtv_header}>
                <div className={styles.phtv_nav}>
                    <h1 className={styles.phtv_logo}>
                        <a href="http://phtv.ifeng.com/" target="_blank">
                            <img
                                src="https://x0.ifengimg.com/ucms/2020_10/A8E4925AEB25C7660C95D0BB27873E5C6E35170F_w165_h59.jpg"
                                alt=""
                            />
                        </a>
                    </h1>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
